import { Box, Flex, Switch, Text } from '@televet/kibble-ui';
import React from 'react';
import useClinicUser from 'shared/hooks/useClinicUser';
import { useUpdateUserPreferencesMutation } from 'shared/types/graphql';

const MyPreferenceSettings = (): JSX.Element => {
  const { clinicUser } = useClinicUser();
  const clinicUserSettings = clinicUser?.userSetting;
  const userSettingId = clinicUserSettings?.id;
  const enterAddsNewLine = clinicUserSettings?.enterAddsNewLine || false;
  const skipLoadingAnimation = clinicUserSettings?.skipLoadingAnimation || false;

  const [updatePreferences] = useUpdateUserPreferencesMutation();

  const handleEnterAddsNewLineChange = (e: React.MouseEvent): void => {
    e.stopPropagation();
    e.preventDefault();
    const checked = clinicUser?.userSetting?.enterAddsNewLine || false;
    updatePreferences({ variables: { where: { id: userSettingId }, data: { enterAddsNewLine: !checked } } });
  };

  const handleSkipLoadingAnimation = (e: React.MouseEvent): void => {
    e.stopPropagation();
    e.preventDefault();
    const checked = clinicUser?.userSetting?.skipLoadingAnimation || false;
    updatePreferences({ variables: { where: { id: userSettingId }, data: { skipLoadingAnimation: !checked } } });
  };

  return (
    <Box padding="20px 10px">
      <Text size="sm">Customize how your Flow experience looks and works.</Text>
      <Flex alignItems="center" mt={8} cursor="pointer" onClick={handleEnterAddsNewLineChange}>
        <Box mr="12px">
          <Switch isChecked={!enterAddsNewLine} />
        </Box>
        <Box flexDirection="column">
          <Text as="p" fontWeight="bold">
            Send a message with &lsquo;Enter&lsquo;
          </Text>
          <Text as="p" size="sm">
            Pressing the &lsquo;enter&lsquo; key will send a message in Team Chat and Conversations.
          </Text>
        </Box>
      </Flex>
      <Flex alignItems="center" mt={8} cursor="pointer" onClick={handleSkipLoadingAnimation}>
        <Box mr="12px">
          <Switch isChecked={skipLoadingAnimation} />
        </Box>
        <Box flexDirection="column">
          <Text as="p" fontWeight="bold">
            Disable loading screen
          </Text>
          <Text as="p" size="sm">
            The loading screen will no longer show when refreshing Flow
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default MyPreferenceSettings;
